import { useAddDefaultCriteriaMutation } from '@redux/api'

import { POSTDefaultCriteria } from '@types'

export const useHandlers = () => {
  const [addDefaultCriterias, { isLoading: isLoadingCriterias }] = useAddDefaultCriteriaMutation()

  const handleAddDefaultCriterias = (values: POSTDefaultCriteria[]) => addDefaultCriterias(values)

  return {
    state: {
      isLoadingCriterias,
    },
    handlers: {
      handleAddDefaultCriterias,
    },
  }
}
